import { extractApiError } from 'utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  changeOwnPasswordRequest,
  createAdminRequest,
  deleteAdminRequest,
  getAdminsRequest,
  resetAdminPasswordRequest,
} from 'api';

export const getAdmins = createAsyncThunk(
  'admin/getAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAdminsRequest();
      return res.data;
    } catch (error: any) {
      return rejectWithValue(extractApiError(error));
    }
  },
);

/**
 * The mutating thunks below all re-read the list on success rather than
 * patching it locally. The server owns which accounts exist, and a create can
 * be rejected server-side (duplicate phone) after the optimistic edit — so a
 * refetch is both simpler and always right.
 */
export const createAdmin = createAsyncThunk(
  'admin/create',
  async (data: { phone: string; password: string }, { rejectWithValue, dispatch }) => {
    try {
      const res = await createAdminRequest(data);
      await dispatch(getAdmins());
      return res.data;
    } catch (error: any) {
      return rejectWithValue(extractApiError(error));
    }
  },
);

export const deleteAdmin = createAsyncThunk(
  'admin/delete',
  async (id: string, { rejectWithValue, dispatch }) => {
    try {
      const res = await deleteAdminRequest(id);
      await dispatch(getAdmins());
      return res.data;
    } catch (error: any) {
      return rejectWithValue(extractApiError(error));
    }
  },
);

export const resetAdminPassword = createAsyncThunk(
  'admin/resetPassword',
  async (
    { id, newPassword }: { id: string; newPassword: string },
    { rejectWithValue },
  ) => {
    try {
      const res = await resetAdminPasswordRequest(id, newPassword);
      return res.data;
    } catch (error: any) {
      return rejectWithValue(extractApiError(error));
    }
  },
);

export const changeOwnPassword = createAsyncThunk(
  'admin/changeOwnPassword',
  async (
    data: { password: string; newPassword: string; passwordConfirm: string },
    { rejectWithValue },
  ) => {
    try {
      const res = await changeOwnPasswordRequest(data);
      return res.data;
    } catch (error: any) {
      return rejectWithValue(extractApiError(error));
    }
  },
);

export const adminThunk = {
  getAdmins,
  createAdmin,
  deleteAdmin,
  resetAdminPassword,
  changeOwnPassword,
};
